import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from '../constants';
import agentKbRootDoc from './agentKbRootDoc';

const converter = {
  toFirestore(item: AgentKb.Artefact): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): AgentKb.Artefact {
    return {
      ...(snapshot.data(options) as AgentKb.Artefact),
      id: snapshot.id,
    };
  },
};

// Artefact heads: agentKb/main/artefacts/{artefactId}. Metadata and front
// matter only — the body is in the revision named by draftRev.
const getAgentKbArtefactsRef = ({
  scope,
  accountId,
  db,
}: {
  scope: AgentKb.ScopeName;
  accountId?: string;
  db?: firebase.firestore.Firestore;
}) =>
  agentKbRootDoc({ scope, accountId, db })
    .collection(STORE_CONSTANTS.AGENT_KB_ARTEFACTS_COLLECTION)
    .withConverter(converter);

export default getAgentKbArtefactsRef;
